document.addEventListener("DOMContentLoaded", function () {
  // Increment Helpful Count
  const helpfulButtons = document.querySelectorAll(".helpful-btn");
  helpfulButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const countSpan = this.querySelector(".helpful-count");
      let currentCount = parseInt(countSpan.textContent);
      countSpan.textContent = currentCount + 1;
    });
  });

  // Fade Out on Scroll
  const reviewObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.style.opacity = entry.isIntersecting ? "1" : "0.5";
      });
    },
    { threshold: 0.1 }
  );
  document.querySelectorAll(".review").forEach((review) => {
    reviewObserver.observe(review);
  });
});
